import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'
import { usePriceElement } from './hooks/usePriceElement'
import { useSlider } from './hooks/useSlider'
import { CommonPriceElementGroup } from './price-element-group'
import { UserPlansResponseInterface } from './price-element-interface'
import { CommonPriceElementPeriod } from './price-element-period'
import { CommonPriceElementPlans } from './price-element-plans'
import {
  CommonPriceElementContainerUi,
  CommonPriceElementPlansWrapperUi,
  CommonPriceElementTableContainerUi,
  CommonPriceElementWrapperUi,
} from './ui'

interface CommonPriceElementProps {
  locale: PageLocaleEnum
  pricePlans: UserPlansResponseInterface[] | null
  isLoading: boolean
  openPopup: (id: number) => void
  t: TFunction
}

export const CommonPriceElement = ({
  locale = PageLocaleEnum.ENGLISH,
  pricePlans,
  isLoading,
  openPopup,
  t,
}: CommonPriceElementProps) => {
  const { activeBtn, priceGroup, pricePeriod, togglePeriod } = usePriceElement({
    locale,
    pricePlans,
  })

  const {
    currentIndex,
    goToNext,
    goToPrev,
    handleEnd,
    handleMouseDown,
    handleMouseMove,
    handleMove,
    handleTouchMove,
    handleTouchStart,
    sliderRef,
    sliderStyles,
  } = useSlider({})

  return (
    <CommonPriceElementWrapperUi>
      <CommonPriceElementContainerUi>
        <CommonPriceElementPlansWrapperUi>
          <CommonPriceElementPeriod
            locale={locale}
            activeBtn={activeBtn}
            onClick={togglePeriod}
            t={t}
            isLoading={isLoading}
          />
          <CommonPriceElementPlans
            locale={locale}
            plans={pricePeriod}
            onClick={openPopup}
            t={t}
            isLoading={isLoading}
            currentIndex={currentIndex}
            goToNext={goToNext}
            goToPrev={goToPrev}
            handleTouchStart={handleTouchStart}
            handleTouchMove={handleTouchMove}
            handleMouseMove={handleMouseMove}
            handleMouseDown={handleMouseDown}
            handleEnd={handleEnd}
            handleMove={handleMove}
            sliderRef={sliderRef}
            sliderStyles={sliderStyles}
          />
        </CommonPriceElementPlansWrapperUi>
        <CommonPriceElementTableContainerUi>
          {priceGroup.map(el => (
            <CommonPriceElementGroup
              key={el.id}
              locale={locale}
              t={t}
              data={el}
              isLoading={isLoading}
              handleTouchStart={handleTouchStart}
              handleTouchMove={handleTouchMove}
              handleMouseMove={handleMouseMove}
              handleMouseDown={handleMouseDown}
              handleEnd={handleEnd}
              handleMove={handleMove}
              sliderStyles={sliderStyles}
            />
          ))}
        </CommonPriceElementTableContainerUi>
      </CommonPriceElementContainerUi>
    </CommonPriceElementWrapperUi>
  )
}
